import { Trans } from 'react-i18next';
import { Link } from '@resideo/blueprint-react';
import React from 'react';
import { UserTerms } from './UserTerms';
import { createMessageHandler } from '../../../utils/createMessageHandler';

const MiddleEastLinks = ({ privacyPolicy, termsUrl }) => {
  const messageHandler = createMessageHandler();

  return (
    <UserTerms>
      <Trans
        i18nKey={'signUp.middleEastCheckBoxText'}
        components={[
          <Link
            key={0}
            data-test-terms-link
            href={!messageHandler.hasMessageHandler ? termsUrl : '#'}
            target='_blank'
            onClick={e => {
              if (messageHandler.hasMessageHandler) {
                e.preventDefault();
                // Signal mobile app to open link in external browser
                postMessage('openExternalUrl', termsUrl);
              }
            }}></Link>,
          <Link
            key={1}
            data-test-privacy-policy-link
            href={!messageHandler.hasMessageHandler ? privacyPolicy : '#'}
            target='_blank'
            onClick={e => {
              if (messageHandler.hasMessageHandler) {
                e.preventDefault();
                // Signal mobile app to open link in external browser
                postMessage('openExternalUrl', privacyPolicy);
              }
            }}></Link>,
        ]}
      />
    </UserTerms>
  );
};

export default MiddleEastLinks;
